import React, { useState, createContext } from "react";
import axios from "axios";
import DietData from "./dietData";
import DietDays from "./dietDays";

export const LabelContext = createContext();





export const LabelProvider = (props) => {
  const [page, setPage] = useState(0);
  const [isSend, setIsSend] = useState(false);
  const [labelInfo, setlabelInfo] = useState({
    address: {
      city: "",
      zipCode: "",
      street: "",
      line1: "",
      line2: "",
    },
    diet: -1,
    dietOption: -1,
    dietDay: -1,
    date: {
      from: undefined,
      to: undefined,
    },
    firstDelivery: undefined,
    isSaturdayCatering : true,
    isSundayCatering : true,
    dayPrice: "",
    totalPrice: "",
    dayCount: "",
    client: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      promo_code: "",      
      info: ""
    }
  });

  const nextPage = () => {
    setPage(page + 1);
  };

  const prevPage = () => {
    setPage(page - 1);
  };

  const confirmOrder = async(priceData, dayPrice, totalPrice, daysCount, firstDeliveryDay, isPromo, discount) => {

    let dataToSend = {
      ...labelInfo,
      dietName : DietData[labelInfo.diet].title,
      dietDayName : DietDays[labelInfo.dietDay].name,
      dietOptionName : DietData[labelInfo.diet].prices[labelInfo.dietOption].option,
      priceData : priceData,
      dateFromTxt : formatDate(labelInfo.date.from),
      dateToTxt : formatDate(labelInfo.date.to),
      firstDeliveryTxt : formatDate(labelInfo.date.from),
      dayPrice : dayPrice,
      totalPrice : totalPrice,
      daysCount : daysCount,
      isPromoCode : isPromo,
      discountValue : discount, 
      isSaturdayCateringTxt : yesNo(labelInfo.isSaturdayCatering),
      isSundayCateringTxt : yesNo(labelInfo.isSundayCatering),
    }

    nextPage();
    
    // if (labelInfo.client.firstName == "SebusI")
    // {
     // console.log("Jest sebus!!!");
      axios.post('/mailer2/order.php', dataToSend)
      .then(function (response) {
        window.location = response.data;
      })
      .catch(function (error) {
        // console.log("Error");
        // console.log(error);
        window.location = "/zamowieniefail"
      });
    // }
    // else
    // {
    //   console.log("Jest normal");
    //   axios.post("/order2.php", dataToSend)
    //   .then((res) => {          
    //     //window.location = res.data;
    //     //console.log("Response: ", res);
    //     //alert("Wiadomość została wysłana");
    //     // setSubmitting(false);
    //    // nextPage()
    //   })
    //   .catch((err) => {
    //      window.location = "/zamowieniefail"
    //      console.log("Error");
    //      console.log(err);
    //     // alert("Wystapil niespodziwany blad. Zamowienie nie zostało zlozone");
    //   });
    // }
   
  };

  const yesNo = (day) => {
    if(day === true)
    {
      return "TAK";
    }
    return "NIE";
  }
  const formatDate = (d) => {
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [day, month, year].join('-');
  }

 // console.log(page, "page");
  const handleChange = (prop) => (event) => {
    //console.log("prop:", prop);
    //console.log("value:", event.target.value);
    setlabelInfo({ ...labelInfo, [prop]: event.target.value });
  };

  const setAddressInfo = (prop) => (event) => {
    setlabelInfo({
      ...labelInfo,
      address: { ...labelInfo.address, [prop]: event.target.value }
    });
  };

  const setDietInfo = (dietId) => {
    setlabelInfo({
      ...labelInfo,
      diet: { ...labelInfo.diet, dietId}
    });
  };

  const setIsSaturdayCatering = (isSaturdayCatering) => {
    setlabelInfo({
      ...labelInfo,
      isSaturdayCatering:  isSaturdayCatering
    });
  };

  const setIsSundayCatering = (isSunday) => {
    setlabelInfo({
      ...labelInfo,
      isSundayCatering: isSunday
    });
  };

  const setDayPrice = (dayPriceValue) => {
    setlabelInfo({
      ...labelInfo,
      dayPrice: dayPriceValue
    });
  };

  const setTotalPrice = (totalPriceValue) => {
    setlabelInfo({
      ...labelInfo,
      totalPrice: totalPriceValue
    });
  };

  const setDayCount = (dayCountValue) => {
    setlabelInfo({
      ...labelInfo,
      dayCount: dayCountValue
    });
  };

  const setFirstDelivery = (dayOfFirstDelivery) => {
    setlabelInfo({
      ...labelInfo,
      firstDelivery: dayOfFirstDelivery
    });
  };


  const setDietOptionInfo = (prop) => (event) => {

    setlabelInfo({
      ...labelInfo,
      dietOption: { ...labelInfo.dietOption, [prop]: event.target.value }
    });
  };
  
  const setDaysInfo = (prop) => (event) => {

    setlabelInfo({
      ...labelInfo,
      dietDay: { ...labelInfo.dietDay, [prop]: event.target.value }
    });
  };

  //console.log(labelInfo.date, "date");
  const setDateInfo = (range) => {
    console.log('range', range);
    setlabelInfo({
      ...labelInfo,
      date: { ...labelInfo.date, from: range.from, to: range.to}
    });
    console.log('labelInfo.date', labelInfo.date);
  };

  const setClientInfo = (prop) => (event) => {
    setlabelInfo({
      ...labelInfo,
      client: { ...labelInfo.client, [prop]: event.target.value }
    });
  };

  const steps = [
    { title: "Dieta" },
    { title: "Wariant" },
    { title: "Posiłki" },
    { title: "Dni dostawy" },
    { title: "Adres dostawy" },
    { title: "Zamówienie" },
  ];

  return (
    <LabelContext.Provider
      value={{
        page,
        steps,
        isSend,
        nextPage,
        prevPage,
        confirmOrder,
        labelInfo,
        handleChange,
        setAddressInfo,
        setDietInfo,
        setDietOptionInfo,
        setDaysInfo,
        setIsSundayCatering,
        setIsSaturdayCatering,
        setDayPrice,
        setTotalPrice,
        setDayCount,
        setFirstDelivery,
        setDateInfo,
        setClientInfo
      }}
    >
      {props.children}
    </LabelContext.Provider>
  );
};
